import {
  changeLeadVaultAccess,
  changeMatchingContactLeadsVaultAccess,
  LEAD_VAULT_ACCESS_TYPES
} from '../../../../project/reducers/leads';
import {
  APPROVE_LEAD_VAULT_ACCESS,
  REVOKE_LEAD_VAULT_ACCESS,
  BLOCK_LEAD_VAULT_ACCESS,
  UNBLOCK_LEAD_VAULT_ACCESS
} from '../../../../project/actions';

export default function (state = [], action) {
  const { updatedLeadId, propertyVaultProfileId } = action.payload;

  switch (action.type) {
  case APPROVE_LEAD_VAULT_ACCESS:
    return changeLeadVaultAccess(state, updatedLeadId, propertyVaultProfileId, LEAD_VAULT_ACCESS_TYPES.APPROVED);
  case REVOKE_LEAD_VAULT_ACCESS:
    return changeLeadVaultAccess(state, updatedLeadId, propertyVaultProfileId, LEAD_VAULT_ACCESS_TYPES.REVOKED);
  case BLOCK_LEAD_VAULT_ACCESS: {
    const updatedLead = state.find(lead => lead.id === action.payload.updatedLeadId);
    return changeMatchingContactLeadsVaultAccess(state, updatedLead, LEAD_VAULT_ACCESS_TYPES.BLOCKED);
  }
  case UNBLOCK_LEAD_VAULT_ACCESS: {
    const updatedLead = state.find(lead => lead.id === action.payload.updatedLeadId);
    return changeMatchingContactLeadsVaultAccess(state, updatedLead, LEAD_VAULT_ACCESS_TYPES.PENDING_APPROVAL);
  }
  default:
    return state;
  }
}
